<div class="p-3">
    <div class="checkbox">
        <input type='checkbox' class='form-check-input me-2' [formControl]='nvdbNavigationService.shareMapState.includeBackgroundLayer'
               style="cursor:pointer"
               id='includeBackground'/>
        <label class='form-check-label' for='includeBackground' style="cursor:pointer">{{ lang.GetValue("ShareMap.IncludeMap")}}</label>
    </div>

    <div class="checkbox">
        <input type='checkbox' class='form-check-input me-2' [formControl]='nvdbNavigationService.shareMapState.includeWmsLayers'
               style="cursor:pointer"
               id='includeLayers'/>
        <label class='form-check-label' for='includeLayers' style="cursor:pointer">{{ lang.GetValue("ShareMap.IncludeLayer")}}</label>
    </div>


    <button class='btn btn-primary d-flex align-items-center gap-2 mt-3' (click)='shareMap()'
            trvTooltip=""
            [position]='toolTipPositions'>
        <!--
                                        <span>
                                            <fa-icon [icon]='faShareAlt'></fa-icon>
                                        </span>
        -->

        {{ lang.GetValue("ShareMap.Copy") }}
        <fa-icon [icon]='faClone'></fa-icon>
    </button>

    <span style="font-size: 11px">{{ lang.GetValue("ShareMap.TxtInfo")}}</span>

</div>
